// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__ul-S8","close":"Header_close__2EcUX","body":"Header_body__3sz4F"};